import React, { useEffect, useRef } from "react";
import "./exclusivos.css"; // Importa el archivo de estilos
import { FaBookOpen } from "react-icons/fa6";
import { MdCloudDownload } from "react-icons/md";
import { FaBoltLightning } from "react-icons/fa6";
import { FaMicrochip } from "react-icons/fa6";

const benefits = [
    { Icon: FaBookOpen, text: "Manual de usuario Volteon" },
    { Icon: MdCloudDownload, text: "Material digital exclusivo" },
    { Icon: FaBoltLightning, text: "Grandioso diseño" },
    { Icon: FaMicrochip, text: "Últimas novedades a tu alcance" },
];

const Exclusivos = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("slide-in"); // Agrega la animación
                    } else {
                        entry.target.classList.remove("slide-in"); // La quita al salir de pantalla
                    }
                });
            },
            { threshold: 0.1 } // Se activa cuando el 10% del componente es visible
        );

        const element = containerRef.current;
        if (element) {
            observer.observe(element);
        }

        return () => {
            if (element) {
                observer.unobserve(element); // Limpieza
            }
        };
    }, []);

    return (
        <div className="box-container" ref={containerRef}>
            {/* Imagen centrada */}
            <img
                src="/images/KitsArduino.png"
                alt="Productos Insignia"
                className="centered-image"
            />

            <span className="kits-eyebrow" aria-hidden="true" />

            {/* Título y párrafo explicativo */}
            <h1 className="title">Productos Insignia</h1>
            <p className="description">
                Los productos insignia de Volteon son productos exclusivos diseñados para ser lo más destacado del mercado. Desde kits hasta placas de microcontrolador llevados al siguiente nivel.
            </p>

            {/* Iconos con beneficios */}
            <div className="icons-container">
                {benefits.map(({ Icon, text }) => (
                    <div className="benefit" key={text}>
                        <div className="benefit-icon-badge">
                            <Icon />
                        </div>
                        <p>{text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Exclusivos;
